import React from 'react';
import { useIntl } from 'react-intl';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import Api from '../../../../../Services/Api';
import TextFieldDefault from '../../TextFieldDefault';

export default function FormOriginalPost({ posts: selectedPosts, handleChange, error }: any) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const intl = useIntl();

  const onChange = async (value: any) => {
    setLoading(true);
    const response = await Api.getPosts({
      types: ['idea'],
      parentId: selectedPosts[0].parent_id,
      search: value,
    });

    const posts = await response.data.data;

    // NOTE: filter the posts that are selected to be grouped to not show up as parents
    setOptions(
      posts.filter((post: any) => !selectedPosts.find((selected: any) => selected.id === post.id)),
    );
    setLoading(false);
  };

  React.useEffect(() => {
    if (!open) {
      onChange('');
    }
  }, [open]);

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      blurOnSelect
      isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
      getOptionLabel={(option: any) => option?.title || ''}
      options={options}
      loading={loading}
      onInputChange={(_e: any, newInputValue: any) => {
        if (newInputValue !== '') {
          onChange(newInputValue);
        }
      }}
      onChange={(_e: any, val: any) => {
        handleChange(val?.id);
      }}
      noOptionsText={intl.formatMessage({ id: 'ORIGINAL_POST.NO_OPTIONS' })}
      renderInput={(params: any) => (
        <TextFieldDefault
          required
          {...params}
          label={intl.formatMessage({ id: 'POSTS.STATUS.ORIGINAL_POST.LABEL' })}
          fullWidth
          error={!!error}
          helperText={error}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  );
}
